/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.151.0-SNAPSHOT
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ErrorRest } from '../models';
// @ts-ignore
import { ZeitplanungEditRest } from '../models';
// @ts-ignore
import { ZeitplanungRest } from '../models';
// @ts-ignore
import { ZeitplanungUpdateRest } from '../models';
/**
 * TerminResourceApi - axios parameter creator
 * @export
 */
export const TerminResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehender Termin in der Zeitplanung eines Verfahrens gelöscht werden.<br> Der zu löschende Termin wird anhand der TerminID in der Zeitplanung ermittelt und gelöscht.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom gelöschten Termin neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom gelöschten Termin neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Löschen eines Termins aus der Zeitplanung.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} terminID TerminID des Termins der gelöscht werden soll
         * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
         * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTermin: async (planID: string, terminID: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('deleteTermin', 'planID', planID)
            // verify required parameter 'terminID' is not null or undefined
            assertParamExists('deleteTermin', 'terminID', terminID)
            const localVarPath = `/verfahren/{planID}/zeitplanung/{terminID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"terminID"}}`, encodeURIComponent(String(terminID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nachfolgendeNeuBerechnen !== undefined) {
                localVarQueryParameter['nachfolgendeNeuBerechnen'] = nachfolgendeNeuBerechnen;
            }

            if (geplanteNeuBerechnen !== undefined) {
                localVarQueryParameter['geplanteNeuBerechnen'] = geplanteNeuBerechnen;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Zeitplanung eines Verfahrens ausgeliefert.<br> Es werden Termine aus aktuellen Durchgängen der Verfahrensschritte als auch von historischen Durchgängen der Verfahrensschritte ausgeliefert.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_READ or ADMIN</p>
         * @summary Endpunkt, der alle Termin der Zeitplanung eines Verfahrens ausliefert.
         * @param {string} planID PlanID vom Verfahren
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeitplanung: async (planID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('getZeitplanung', 'planID', planID)
            const localVarPath = `/verfahren/{planID}/zeitplanung`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird für ein Verfahren die Zeitplanung initialisiert.<br> D.h. es wird für alle Termine gemäß der Verfahrenskonfiguration ausgehend vom prognoseStartdatum die initiale Prognose durchgeführt.<br> Die prognostizierten Termine werden in der Datenbank persistiert.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt, mit dem die Zeitplanung eines Verfahrens initialisiert wird.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} prognoseStartdatum Startdatum für Prognoseberechnung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeZeitplanung: async (planID: string, prognoseStartdatum: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('initializeZeitplanung', 'planID', planID)
            // verify required parameter 'prognoseStartdatum' is not null or undefined
            assertParamExists('initializeZeitplanung', 'prognoseStartdatum', prognoseStartdatum)
            const localVarPath = `/verfahren/{planID}/zeitplanung/init`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (prognoseStartdatum !== undefined) {
                localVarQueryParameter['prognoseStartdatum'] = (prognoseStartdatum as any instanceof Date) ?
                    (prognoseStartdatum as any).toISOString() :
                    prognoseStartdatum;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird geprüft, ob ein Termin anhand des neuen übergebenen Zeitraum zu einer Verzögerung führt.<br> Diese Funktionalität wird vom Frontend zur Signalisierung verwendet, wenn ein Termin geändert werden soll bei dem<br> dann nachfolgende Termine zu einer Verzögerung (Monitoring) führen.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom übergebenen Termin und neuen Zeitraum neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom übergebenen Termin und neuen Zeitraum neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_READ or ADMIN</p>
         * @summary Endpunkt mit dem geprüft wird, ob ein Termin anhand des übergebenen Zeitraums verzögert ist.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} terminID TerminID des Termins der geändert werden soll
         * @param {string} zeitraumBeginn Beginn des neuen Zeitraums
         * @param {string} [zeitraumEnde] Ende des neuen Zeitraums
         * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
         * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isVerzoegert: async (planID: string, terminID: string, zeitraumBeginn: string, zeitraumEnde?: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('isVerzoegert', 'planID', planID)
            // verify required parameter 'terminID' is not null or undefined
            assertParamExists('isVerzoegert', 'terminID', terminID)
            // verify required parameter 'zeitraumBeginn' is not null or undefined
            assertParamExists('isVerzoegert', 'zeitraumBeginn', zeitraumBeginn)
            const localVarPath = `/verfahren/{planID}/zeitplanung/{terminID}/istverzoegert`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"terminID"}}`, encodeURIComponent(String(terminID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (zeitraumBeginn !== undefined) {
                localVarQueryParameter['zeitraumBeginn'] = (zeitraumBeginn as any instanceof Date) ?
                    (zeitraumBeginn as any).toISOString() :
                    zeitraumBeginn;
            }

            if (zeitraumEnde !== undefined) {
                localVarQueryParameter['zeitraumEnde'] = (zeitraumEnde as any instanceof Date) ?
                    (zeitraumEnde as any).toISOString() :
                    zeitraumEnde;
            }

            if (nachfolgendeNeuBerechnen !== undefined) {
                localVarQueryParameter['nachfolgendeNeuBerechnen'] = nachfolgendeNeuBerechnen;
            }

            if (geplanteNeuBerechnen !== undefined) {
                localVarQueryParameter['geplanteNeuBerechnen'] = geplanteNeuBerechnen;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehender Termin in der Zeitplanung eines Verfahrens aktualisiert werden.<br> Der zu aktualisierende Termin muss in der Liste der Zeitplanungstermine übergeben werden.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom aktualisierten Termin neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom aktualisierten Termin neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Aktualisieren eines bestehenden Termins in der Zeitplanung.
         * @param {ZeitplanungUpdateRest} zeitplanungUpdateRest Liste aller Termine aus der Terminplanung inkl. des zu aktualisierenden Termins.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} terminID TerminID des Termins der aktualisiert werden soll
         * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
         * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZeitplanungExisting: async (zeitplanungUpdateRest: ZeitplanungUpdateRest, planID: string, terminID: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zeitplanungUpdateRest' is not null or undefined
            assertParamExists('updateZeitplanungExisting', 'zeitplanungUpdateRest', zeitplanungUpdateRest)
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('updateZeitplanungExisting', 'planID', planID)
            // verify required parameter 'terminID' is not null or undefined
            assertParamExists('updateZeitplanungExisting', 'terminID', terminID)
            const localVarPath = `/verfahren/{planID}/zeitplanung/{terminID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"terminID"}}`, encodeURIComponent(String(terminID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nachfolgendeNeuBerechnen !== undefined) {
                localVarQueryParameter['nachfolgendeNeuBerechnen'] = nachfolgendeNeuBerechnen;
            }

            if (geplanteNeuBerechnen !== undefined) {
                localVarQueryParameter['geplanteNeuBerechnen'] = geplanteNeuBerechnen;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zeitplanungUpdateRest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann der Zeitplanung eines Verfahrens ein Termin hinzugefügt werden.<br> Der neue Termin muss in der Liste der Zeitplanungstermine übergeben werden.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom neuen Termin neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom neuen Termin neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Hinzufügen eines neuen Termins in der Zeitplanung.
         * @param {ZeitplanungEditRest} zeitplanungEditRest Liste aller Termine aus der Terminplanung inkl. des neuen Termins.
         * @param {string} planID PlanID vom Verfahren
         * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
         * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZeitplanungNew: async (zeitplanungEditRest: ZeitplanungEditRest, planID: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zeitplanungEditRest' is not null or undefined
            assertParamExists('updateZeitplanungNew', 'zeitplanungEditRest', zeitplanungEditRest)
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('updateZeitplanungNew', 'planID', planID)
            const localVarPath = `/verfahren/{planID}/zeitplanung/neu`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nachfolgendeNeuBerechnen !== undefined) {
                localVarQueryParameter['nachfolgendeNeuBerechnen'] = nachfolgendeNeuBerechnen;
            }

            if (geplanteNeuBerechnen !== undefined) {
                localVarQueryParameter['geplanteNeuBerechnen'] = geplanteNeuBerechnen;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zeitplanungEditRest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminResourceApi - functional programming interface
 * @export
 */
export const TerminResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehender Termin in der Zeitplanung eines Verfahrens gelöscht werden.<br> Der zu löschende Termin wird anhand der TerminID in der Zeitplanung ermittelt und gelöscht.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom gelöschten Termin neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom gelöschten Termin neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Löschen eines Termins aus der Zeitplanung.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} terminID TerminID des Termins der gelöscht werden soll
         * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
         * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTermin(planID: string, terminID: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZeitplanungRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTermin(planID, terminID, nachfolgendeNeuBerechnen, geplanteNeuBerechnen, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminResourceApi.deleteTermin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Zeitplanung eines Verfahrens ausgeliefert.<br> Es werden Termine aus aktuellen Durchgängen der Verfahrensschritte als auch von historischen Durchgängen der Verfahrensschritte ausgeliefert.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_READ or ADMIN</p>
         * @summary Endpunkt, der alle Termin der Zeitplanung eines Verfahrens ausliefert.
         * @param {string} planID PlanID vom Verfahren
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZeitplanung(planID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZeitplanungRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZeitplanung(planID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminResourceApi.getZeitplanung']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird für ein Verfahren die Zeitplanung initialisiert.<br> D.h. es wird für alle Termine gemäß der Verfahrenskonfiguration ausgehend vom prognoseStartdatum die initiale Prognose durchgeführt.<br> Die prognostizierten Termine werden in der Datenbank persistiert.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt, mit dem die Zeitplanung eines Verfahrens initialisiert wird.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} prognoseStartdatum Startdatum für Prognoseberechnung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initializeZeitplanung(planID: string, prognoseStartdatum: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZeitplanungRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initializeZeitplanung(planID, prognoseStartdatum, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminResourceApi.initializeZeitplanung']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird geprüft, ob ein Termin anhand des neuen übergebenen Zeitraum zu einer Verzögerung führt.<br> Diese Funktionalität wird vom Frontend zur Signalisierung verwendet, wenn ein Termin geändert werden soll bei dem<br> dann nachfolgende Termine zu einer Verzögerung (Monitoring) führen.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom übergebenen Termin und neuen Zeitraum neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom übergebenen Termin und neuen Zeitraum neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_READ or ADMIN</p>
         * @summary Endpunkt mit dem geprüft wird, ob ein Termin anhand des übergebenen Zeitraums verzögert ist.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} terminID TerminID des Termins der geändert werden soll
         * @param {string} zeitraumBeginn Beginn des neuen Zeitraums
         * @param {string} [zeitraumEnde] Ende des neuen Zeitraums
         * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
         * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isVerzoegert(planID: string, terminID: string, zeitraumBeginn: string, zeitraumEnde?: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isVerzoegert(planID, terminID, zeitraumBeginn, zeitraumEnde, nachfolgendeNeuBerechnen, geplanteNeuBerechnen, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminResourceApi.isVerzoegert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehender Termin in der Zeitplanung eines Verfahrens aktualisiert werden.<br> Der zu aktualisierende Termin muss in der Liste der Zeitplanungstermine übergeben werden.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom aktualisierten Termin neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom aktualisierten Termin neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Aktualisieren eines bestehenden Termins in der Zeitplanung.
         * @param {ZeitplanungUpdateRest} zeitplanungUpdateRest Liste aller Termine aus der Terminplanung inkl. des zu aktualisierenden Termins.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} terminID TerminID des Termins der aktualisiert werden soll
         * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
         * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateZeitplanungExisting(zeitplanungUpdateRest: ZeitplanungUpdateRest, planID: string, terminID: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZeitplanungRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateZeitplanungExisting(zeitplanungUpdateRest, planID, terminID, nachfolgendeNeuBerechnen, geplanteNeuBerechnen, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminResourceApi.updateZeitplanungExisting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann der Zeitplanung eines Verfahrens ein Termin hinzugefügt werden.<br> Der neue Termin muss in der Liste der Zeitplanungstermine übergeben werden.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom neuen Termin neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom neuen Termin neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Hinzufügen eines neuen Termins in der Zeitplanung.
         * @param {ZeitplanungEditRest} zeitplanungEditRest Liste aller Termine aus der Terminplanung inkl. des neuen Termins.
         * @param {string} planID PlanID vom Verfahren
         * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
         * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateZeitplanungNew(zeitplanungEditRest: ZeitplanungEditRest, planID: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZeitplanungRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateZeitplanungNew(zeitplanungEditRest, planID, nachfolgendeNeuBerechnen, geplanteNeuBerechnen, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TerminResourceApi.updateZeitplanungNew']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TerminResourceApi - factory interface
 * @export
 */
export const TerminResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminResourceApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehender Termin in der Zeitplanung eines Verfahrens gelöscht werden.<br> Der zu löschende Termin wird anhand der TerminID in der Zeitplanung ermittelt und gelöscht.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom gelöschten Termin neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom gelöschten Termin neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Löschen eines Termins aus der Zeitplanung.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} terminID TerminID des Termins der gelöscht werden soll
         * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
         * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTermin(planID: string, terminID: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options?: any): AxiosPromise<ZeitplanungRest> {
            return localVarFp.deleteTermin(planID, terminID, nachfolgendeNeuBerechnen, geplanteNeuBerechnen, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Zeitplanung eines Verfahrens ausgeliefert.<br> Es werden Termine aus aktuellen Durchgängen der Verfahrensschritte als auch von historischen Durchgängen der Verfahrensschritte ausgeliefert.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_READ or ADMIN</p>
         * @summary Endpunkt, der alle Termin der Zeitplanung eines Verfahrens ausliefert.
         * @param {string} planID PlanID vom Verfahren
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeitplanung(planID: string, options?: any): AxiosPromise<ZeitplanungRest> {
            return localVarFp.getZeitplanung(planID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird für ein Verfahren die Zeitplanung initialisiert.<br> D.h. es wird für alle Termine gemäß der Verfahrenskonfiguration ausgehend vom prognoseStartdatum die initiale Prognose durchgeführt.<br> Die prognostizierten Termine werden in der Datenbank persistiert.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt, mit dem die Zeitplanung eines Verfahrens initialisiert wird.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} prognoseStartdatum Startdatum für Prognoseberechnung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeZeitplanung(planID: string, prognoseStartdatum: string, options?: any): AxiosPromise<ZeitplanungRest> {
            return localVarFp.initializeZeitplanung(planID, prognoseStartdatum, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird geprüft, ob ein Termin anhand des neuen übergebenen Zeitraum zu einer Verzögerung führt.<br> Diese Funktionalität wird vom Frontend zur Signalisierung verwendet, wenn ein Termin geändert werden soll bei dem<br> dann nachfolgende Termine zu einer Verzögerung (Monitoring) führen.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom übergebenen Termin und neuen Zeitraum neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom übergebenen Termin und neuen Zeitraum neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_READ or ADMIN</p>
         * @summary Endpunkt mit dem geprüft wird, ob ein Termin anhand des übergebenen Zeitraums verzögert ist.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} terminID TerminID des Termins der geändert werden soll
         * @param {string} zeitraumBeginn Beginn des neuen Zeitraums
         * @param {string} [zeitraumEnde] Ende des neuen Zeitraums
         * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
         * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isVerzoegert(planID: string, terminID: string, zeitraumBeginn: string, zeitraumEnde?: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options?: any): AxiosPromise<boolean> {
            return localVarFp.isVerzoegert(planID, terminID, zeitraumBeginn, zeitraumEnde, nachfolgendeNeuBerechnen, geplanteNeuBerechnen, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehender Termin in der Zeitplanung eines Verfahrens aktualisiert werden.<br> Der zu aktualisierende Termin muss in der Liste der Zeitplanungstermine übergeben werden.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom aktualisierten Termin neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom aktualisierten Termin neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Aktualisieren eines bestehenden Termins in der Zeitplanung.
         * @param {ZeitplanungUpdateRest} zeitplanungUpdateRest Liste aller Termine aus der Terminplanung inkl. des zu aktualisierenden Termins.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} terminID TerminID des Termins der aktualisiert werden soll
         * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
         * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZeitplanungExisting(zeitplanungUpdateRest: ZeitplanungUpdateRest, planID: string, terminID: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options?: any): AxiosPromise<ZeitplanungRest> {
            return localVarFp.updateZeitplanungExisting(zeitplanungUpdateRest, planID, terminID, nachfolgendeNeuBerechnen, geplanteNeuBerechnen, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann der Zeitplanung eines Verfahrens ein Termin hinzugefügt werden.<br> Der neue Termin muss in der Liste der Zeitplanungstermine übergeben werden.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom neuen Termin neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom neuen Termin neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Hinzufügen eines neuen Termins in der Zeitplanung.
         * @param {ZeitplanungEditRest} zeitplanungEditRest Liste aller Termine aus der Terminplanung inkl. des neuen Termins.
         * @param {string} planID PlanID vom Verfahren
         * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
         * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZeitplanungNew(zeitplanungEditRest: ZeitplanungEditRest, planID: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options?: any): AxiosPromise<ZeitplanungRest> {
            return localVarFp.updateZeitplanungNew(zeitplanungEditRest, planID, nachfolgendeNeuBerechnen, geplanteNeuBerechnen, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminResourceApi - object-oriented interface
 * @export
 * @class TerminResourceApi
 * @extends {BaseAPI}
 */
export class TerminResourceApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehender Termin in der Zeitplanung eines Verfahrens gelöscht werden.<br> Der zu löschende Termin wird anhand der TerminID in der Zeitplanung ermittelt und gelöscht.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom gelöschten Termin neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom gelöschten Termin neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
     * @summary Endpunkt zum Löschen eines Termins aus der Zeitplanung.
     * @param {string} planID PlanID vom Verfahren
     * @param {string} terminID TerminID des Termins der gelöscht werden soll
     * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
     * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminResourceApi
     */
    public deleteTermin(planID: string, terminID: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options?: RawAxiosRequestConfig) {
        return TerminResourceApiFp(this.configuration).deleteTermin(planID, terminID, nachfolgendeNeuBerechnen, geplanteNeuBerechnen, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Termine der Zeitplanung eines Verfahrens ausgeliefert.<br> Es werden Termine aus aktuellen Durchgängen der Verfahrensschritte als auch von historischen Durchgängen der Verfahrensschritte ausgeliefert.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_READ or ADMIN</p>
     * @summary Endpunkt, der alle Termin der Zeitplanung eines Verfahrens ausliefert.
     * @param {string} planID PlanID vom Verfahren
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminResourceApi
     */
    public getZeitplanung(planID: string, options?: RawAxiosRequestConfig) {
        return TerminResourceApiFp(this.configuration).getZeitplanung(planID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird für ein Verfahren die Zeitplanung initialisiert.<br> D.h. es wird für alle Termine gemäß der Verfahrenskonfiguration ausgehend vom prognoseStartdatum die initiale Prognose durchgeführt.<br> Die prognostizierten Termine werden in der Datenbank persistiert.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
     * @summary Endpunkt, mit dem die Zeitplanung eines Verfahrens initialisiert wird.
     * @param {string} planID PlanID vom Verfahren
     * @param {string} prognoseStartdatum Startdatum für Prognoseberechnung
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminResourceApi
     */
    public initializeZeitplanung(planID: string, prognoseStartdatum: string, options?: RawAxiosRequestConfig) {
        return TerminResourceApiFp(this.configuration).initializeZeitplanung(planID, prognoseStartdatum, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird geprüft, ob ein Termin anhand des neuen übergebenen Zeitraum zu einer Verzögerung führt.<br> Diese Funktionalität wird vom Frontend zur Signalisierung verwendet, wenn ein Termin geändert werden soll bei dem<br> dann nachfolgende Termine zu einer Verzögerung (Monitoring) führen.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom übergebenen Termin und neuen Zeitraum neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom übergebenen Termin und neuen Zeitraum neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_READ or ADMIN</p>
     * @summary Endpunkt mit dem geprüft wird, ob ein Termin anhand des übergebenen Zeitraums verzögert ist.
     * @param {string} planID PlanID vom Verfahren
     * @param {string} terminID TerminID des Termins der geändert werden soll
     * @param {string} zeitraumBeginn Beginn des neuen Zeitraums
     * @param {string} [zeitraumEnde] Ende des neuen Zeitraums
     * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
     * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminResourceApi
     */
    public isVerzoegert(planID: string, terminID: string, zeitraumBeginn: string, zeitraumEnde?: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options?: RawAxiosRequestConfig) {
        return TerminResourceApiFp(this.configuration).isVerzoegert(planID, terminID, zeitraumBeginn, zeitraumEnde, nachfolgendeNeuBerechnen, geplanteNeuBerechnen, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehender Termin in der Zeitplanung eines Verfahrens aktualisiert werden.<br> Der zu aktualisierende Termin muss in der Liste der Zeitplanungstermine übergeben werden.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom aktualisierten Termin neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom aktualisierten Termin neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
     * @summary Endpunkt zum Aktualisieren eines bestehenden Termins in der Zeitplanung.
     * @param {ZeitplanungUpdateRest} zeitplanungUpdateRest Liste aller Termine aus der Terminplanung inkl. des zu aktualisierenden Termins.
     * @param {string} planID PlanID vom Verfahren
     * @param {string} terminID TerminID des Termins der aktualisiert werden soll
     * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
     * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminResourceApi
     */
    public updateZeitplanungExisting(zeitplanungUpdateRest: ZeitplanungUpdateRest, planID: string, terminID: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options?: RawAxiosRequestConfig) {
        return TerminResourceApiFp(this.configuration).updateZeitplanungExisting(zeitplanungUpdateRest, planID, terminID, nachfolgendeNeuBerechnen, geplanteNeuBerechnen, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann der Zeitplanung eines Verfahrens ein Termin hinzugefügt werden.<br> Der neue Termin muss in der Liste der Zeitplanungstermine übergeben werden.<br> Der Parameter nachfolgendeNeuBerechnen steuert, ob automatisch alle nachfolgenden Termine ausgehend vom neuen Termin neu berechnet werden sollen.<br> Der Parameter geplanteNeuBerechnen steuert, ob automatisch alle nachfolgenden geplanten Termine ausgehend vom neuen Termin neu berechnet werden sollen.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
     * @summary Endpunkt zum Hinzufügen eines neuen Termins in der Zeitplanung.
     * @param {ZeitplanungEditRest} zeitplanungEditRest Liste aller Termine aus der Terminplanung inkl. des neuen Termins.
     * @param {string} planID PlanID vom Verfahren
     * @param {boolean} [nachfolgendeNeuBerechnen] alle nachfolgenden Termine neu berechnen
     * @param {boolean} [geplanteNeuBerechnen] alle nachfolgenden geplanten Termine neu berechnen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminResourceApi
     */
    public updateZeitplanungNew(zeitplanungEditRest: ZeitplanungEditRest, planID: string, nachfolgendeNeuBerechnen?: boolean, geplanteNeuBerechnen?: boolean, options?: RawAxiosRequestConfig) {
        return TerminResourceApiFp(this.configuration).updateZeitplanungNew(zeitplanungEditRest, planID, nachfolgendeNeuBerechnen, geplanteNeuBerechnen, options).then((request) => request(this.axios, this.basePath));
    }
}

